import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import img1 from "../../assets/images/boostImg1.webp";
import img2 from "../../assets/images/boostImg2.webp";
import img3 from "../../assets/images/boostImg3.webp";
import img4 from "../../assets/images/boostImg4.webp";
import designing from "../../assets/icons/DesigningIcon.svg";
import webDevelopment from "../../assets/icons/webAppDevelopmentIcon.svg";
import marketing from "../../assets/icons/MarketingIcon.svg";
import maintenance from "../../assets/icons/MaintenanceIcon.svg";
import motionGraphics from "../../assets/icons/MotionAndGraphicsIcon.svg";
import { Link } from "react-router-dom";

type exploreType = {
  icon: string;
  name: string;
  path: string;
};

const explores: exploreType[] = [
  {
    icon: designing,
    name: "Designing",
    path: "/ui-ux-designing",
  },
  {
    icon: webDevelopment,
    name: "Web & App development",
    path: "/web-app-development",
  },
  {
    icon: marketing,
    name: "Marketing",
    path: "/personal-branding",
  },
  {
    icon: maintenance,
    name: "Maintenance & Support",
    path: "/it-support-maintenance",
  },
  {
    icon: motionGraphics,
    name: "Motion Graphics & Video Editing",
    path: "/youtube-video-editing",
  },
];

const BoostBussiness = () => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? "bg-white" : "bg-black"
      } transition-all duration-500`}
    >
      <div className="max-w-screen-2xl mx-auto px-5 sm:px-20 py-8 sm:py-28">
        <div className="flex flex-col lg:flex-row">
          <div className="lg:w-[40%]">
            <div className="">
              <div
                className={`${
                  theme === "dark" ? "bg-primary" : "bg-[#141414]"
                } py-[14px] pr-[14px] pl-[50px] rounded-full mb-3`}
              >
                <img className="w-full" src={img1} alt="" />
              </div>
              <div className="flex gap-3">
                <div className="w-[50%]">
                  <div className="flex flex-col gap-3">
                    <div
                      className={`${
                        theme === "dark" ? "bg-primary" : "bg-[#141414]"
                      } h-[50%] rounded-full p-[14px]`}
                    >
                      <img
                        src={img2}
                        className="h-full w-full object-cover object-center rounded-full"
                        alt=""
                      />
                    </div>
                    <div
                      className={`${
                        theme === "dark" ? "bg-primary" : "bg-[#141414]"
                      } h-[50%] rounded-full p-[14px]`}
                    >
                      <img
                        src={img3}
                        className="h-full w-full object-cover object-center rounded-full"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`${
                    theme === "dark" ? "bg-primary" : "bg-[#141414]"
                  } w-[50%] p-[14px] rounded-full`}
                >
                  <img
                    src={img4}
                    className="h-full w-full object-cover object-center rounded-full"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="lg:w-[60%]">
            <div className="hidden lg:flex flex-col justify-center h-full pl-[32px]">
              <h3
                className={`${
                  theme === "dark" ? "text-black" : "text-white"
                } bricolage-grotesque-bold text-[54px] mb-8 leading-[123%]`}
              >
                We Boost 
                <br /> Your Business
              </h3>
              <div className="flex flex-col">
                {explores.map((item, index) => (
                  <div className="py-7 border-t flex justify-between" key={index}>
                    <div className="flex gap-10 items-center">
                      <div
                        className={`${
                          theme === "dark" ? "bg-[#2a2a2a]" : "bg-secondary"
                        } size-14 flex justify-center items-center rounded-full`}
                      >
                        <img className="" alt="" src={item.icon} />
                      </div>
                      <h4
                        className={`${
                          theme === "dark" ? "text-black" : "text-white"
                        } font-gtAmerica font-medium text-2xl `}
                      >
                        {item.name}
                      </h4>
                    </div>
                    <Link
                      to={item.path}
                      className=""
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                    >
                      <div
                        className={`${
                          theme === "dark" ? "bg-primary" : "card-gradient"
                        }  p-[2px] rounded-full`}
                      >
                        <button
                          key={index}
                          className={`${
                            theme === "dark"
                              ? "bg-primary text-white hover:bg-black transition-all duration-500"
                              : "bg-black text-white hover:bg-primary transition-all duration-500"
                          } py-2 px-14  rounded-3xl font-gtAmerica font-semibold`}
                        >
                          Explore
                        </button>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:hidden">
              <div className="">
                <h3
                  className={`${
                    theme === "dark" ? "text-black" : "text-white"
                  } bricolage-grotesque-bold text-[32px] my-8 leading-[123%] text-center`}
                >
                  We Boost
                  <br /> Your Business
                </h3>
                <div className="flex flex-col gap-5">
                  {explores.map((item, index) => (
                    <Link to={item.path} key={index} onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }>
                      <div
                        className={`${
                          theme === "dark" ? "bg-primary" : "card-gradient"
                        } p-[1px] rounded-[16px]`}
                      >
                        <div
                          className={`${
                            theme === "dark" ? "bg-primary" : "bg-[#151415]"
                          } flex flex-col justify-center items-center py-12 rounded-[16px]`}
                        >
                          <div
                            className={`${
                              theme === "dark" ? "bg-[#2a2a2a]" : "bg-secondary"
                            } size-14 flex justify-center items-center rounded-full mb-4`}
                          >
                            <img className="" alt="" src={item.icon} />
                          </div>
                          <h4
                            className={`${
                              theme === "dark" ? "text-white" : "text-white"
                            } font-gtAmerica font-medium text-2xl text-center`}
                          >
                            {item.name}
                          </h4>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoostBussiness;
